import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { GradientBorderBox } from "../../../../../../Components";
import { spliter } from "../../../../../../Utils/Spliter";

export default function CartListDesktopRow({
  title,
  price,
  qty,
  weight,
  prCode,
  vrCode,
  addPrToCart,
  removePrToCart,
  clearPrToCart,
  clearFullyCart,
  img,
  max,
}) {
  const theme = useTheme();
  return (
    <>
      <Stack
        direction={"row"}
        sx={{
          borderRadius: "8px",
          direction: "rtl",
          color: theme.palette.primary.main,
          // border: `2px solid ${theme.palette.primary.main}`,
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          my: ".2rem",
          zIndex: "1000",
          // bgcolor: theme.palette.background.lightCream,
        }}
      >
        <Stack
          direction={"row"}
          sx={{
            width: "30%",
            gap: "1rem",
            alignItems: "center",
            padding: ".5rem .7rem",
          }}
        >
          <Box
            sx={{
              width: "50px",
              height: "50px",
              borderRadius: ".3rem",
              overflow: "hidden",
            }}
          >
            <img
              style={{ width: "100%", height: "100%" }}
              src={
                img?.[0]?.file_name
                  ? import.meta.env.VITE_URL + img?.[0]?.file_name
                  : "/Media/nimobileIcon.png"
              }
              alt={import.meta.env.VITE_URL + img?.[0]?.alt}
            />
          </Box>
          <Typography sx={{ fontSize: ".8rem", width: "80%" }}>
            {spliter({ text: title, limit: 100, mobileLimit: 50 }) || "-"}
          </Typography>
        </Stack>

        {/* G */}

        <Typography
          sx={{
            width: "10%",
            textAlign: "center",
            fontSize: ".8rem",
          }}
        >
          {weight || "-" + "رنگ"}
        </Typography>

        {/* Price */}
        <Typography
          sx={{
            width: "20%",
            textAlign: "center",
            fontSize: ".8rem",
          }}
        >
          {price?.toLocaleString() || "-"}
        </Typography>

        {/* Count */}
        <Stack
          sx={{
            gap: ".5rem",
            alignItems: "center",
            justifyContent: "center",
            width: "15%",
          }}
          direction={"row-reverse"}
        >
          {/* Add */}
          <IconButton
            sx={{
              bgcolor: theme.palette.primary.main,
              borderRadius: "4px",
              transition: "all .3s",
              color: theme.palette.background.default,
              padding: "2px",
              "&:hover": {
                bgcolor: theme.palette.primary.main,
              },
            }}
            disabled={max == qty ? true : false}
            onClick={() => {
              addPrToCart(prCode, vrCode);
            }}
          >
            <AddIcon sx={{ fontSize: "1.4rem" }} />
          </IconButton>
          <Typography fontSize={".8rem"}> {qty || "-"}</Typography>
          {/* Remove */}
          <IconButton
            sx={{
              bgcolor: theme.palette.primary.main,
              borderRadius: "4px",
              color: theme.palette.background.default,
              transition: "all .3s",
              padding: "2px",
              "&:hover": {
                bgcolor: theme.palette.primary.main,
              },
            }}
            onClick={() => {
              removePrToCart();
            }}
          >
            <RemoveIcon sx={{ fontSize: "1.4rem" }} />
          </IconButton>
        </Stack>

        {/* Full Price */}
        <Typography
          sx={{ fontSize: ".8rem", textAlign: "center", width: "20%" }}
        >
          {(+price * +qty)?.toLocaleString() || "-"}
        </Typography>

        {/* DeleteButton */}
        <Stack sx={{ width: "5%", justifyContent: "end" }}>
          <IconButton
            onClick={() => {
              clearPrToCart();
            }}
            sx={{
              color: theme.palette.primary.main,
              borderRadius: "4px",
              padding: "2px",
            }}
            color="error"
          >
            <DeleteForeverIcon sx={{ fontSize: "2.3rem" }} />
          </IconButton>
        </Stack>
        <GradientBorderBox
          bgGrad={`linear-gradient(
    90deg,
    #fff -70%,
    #313131 50%,
     #DCB868 130%
  )`}
          radius=".5rem"
        />
      </Stack>
    </>
  );
}
